<script setup lang="ts">
import TheGlobalAnnouncementMessage from './TheGlobalAnnouncementMessage.vue';
import AdminAnnouncementPageDisplayEnum from '@/domains/admin/typescript/AdminAnnouncementPageDisplayEnum';
import useAdminAnnouncementStore from '@/domains/admin/store/adminAnnouncement.store';
import { computed } from 'vue';
import { useStorage } from '@vueuse/core';

const adminAnnouncementStore = useAdminAnnouncementStore();
const { getActiveAnnouncementsByLocation } = adminAnnouncementStore;

const hiddenAnnouncements = useStorage('hiddenAnnouncements', [] as number[]);

const announcementsToDisplay = computed(() => {
    return getActiveAnnouncementsByLocation(AdminAnnouncementPageDisplayEnum.GLOBAL).filter(
        (announcement) => !hiddenAnnouncements.value.includes(announcement.id),
    );
});

function hideAnnouncement(id: number) {
    hiddenAnnouncements.value.push(id);
}
</script>

<template>
    <div v-if="announcementsToDisplay.length > 0" class="mt-2 flex w-full flex-col gap-2 px-6">
        <TheGlobalAnnouncementMessage
            v-for="(announcement, index) in announcementsToDisplay"
            :key="index"
            :announcement="announcement"
            @hide="hideAnnouncement"
        />
    </div>
</template>
